import * as React from 'react';
import {observer} from 'mobx-react';
import {UIState} from "data/UIState";
import {NavAvatar} from "components/nav/NavAvatar";
import {PageEnums} from "components/nav/PageEnums";
import {WellnessConceptsLogo} from "components/widgets/WellnessConceptsLogo";
import {ManagerPill} from "components/dashboard/ManagerPill";

import './DashboardTopBar.pcss';

interface Props {
  customerName:string;
}
export const DashboardTopBar = observer((props:Props) => {

  return (
    <div className={"dashboardTopBar"}>
        <div className={'lft'}>
          <WellnessConceptsLogo variant={'favicon gradient'} />
          <h1 tabIndex={0}>
            <span className={'wellness-concepts'}>Wellness Concepts</span>
            <span className={'for-customer'}> for {props.customerName}</span>
          </h1>
        </div>
        <div className={'rt'}>
          <ManagerPill />
          <a role={"button"} tabIndex={0} aria-label="Edit account profile" onClick={()=>{ UIState.currentPage = PageEnums.profile; }} >
            <NavAvatar user={UIState.user} variant={'medium'} />
          </a>
        </div>
    </div>

  )
});
